<template>
  <div>
    <h3>INFORMACION A USUARIOS FINANCIEROS</h3>
    <h4>Tasas, comisiones y cargos</h4>
    <div style="overflow-x: auto">
      <table>
        <tr>
          <th>Producto</th>
          <th>Plazo</th>
          <th></th>
          <th>Tasa Nominal<br />Anual (TNA)</th>
          <th>Tasa<br />Efectiva<br />Anual (TEA)</th>
          <th>CFTNA con<br />IVA</th>
          <th>CFTEA con<br />IVA</th>
          <th>Comisiones</th>
          <th>Precancelacion<br />anticipada</th>
          <th>Seguros</th>
        </tr>
        <tr>
          <td>Prestamos personales</td>
          <td>3 a 24 meses</td>
          <td>Minima<br />Maxima</td>
          <td>
            {{ this.$tasas().TnaSinIvaMin }}%<br />{{
              this.$tasas().TnaSinIvaMax
            }}%
          </td>
          <td>
            {{ this.$tasas().TeaSinIvaMin }}%<br />{{
              this.$tasas().TeaSinIvaMax
            }}%
          </td>
          <td>
            {{ this.$tasas().CftnaConIvaMin }}%<br />{{
              this.$tasas().CftnaConIvaMax
            }}%
          </td>
          <td>
            {{ this.$tasas().CfteaConIvaMin }}%<br />{{
              this.$tasas().CfteaConIvaMax
            }}%
          </td>
          <td>0%<br />0%</td>
          <td>0%<br />0%</td>
          <td>0%<br />0%</td>
        </tr>
      </table>
    </div>
    <h5>Desliza hacia la derecha para ver la tabla completa.</h5>
  </div>
</template>

<script>
export default {
  name: "PersonalAllons",
  methods: {},
};
</script>


<style scoped>
.textAlignLeft {
  text-align: left;
  margin-left: 100px;
}
table {
  width: 100%;
}
th {
  text-align: center;
  padding: 0px 10px;
}
td {
  text-align: left;
  padding: 0px 10px;
}
</style>
